import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { EFArrowRightForAni } from '@/components/UI/svg/ProductStatic';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/deltamax/pc/');
export default function Comp({}: any) {
    const { Link, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_max_static');

    return (
        <div className={`${css.gsapdGroupA} gsapdGroupA1`}>
            <div className="a-msg-box">
                <div className="msg-line-a1">{t('SP')}</div>
                <div className="msg-line-a2">
                    {t.rich('SP_desc', {
                        line1: (child: string) => <span className="msg-color1">{child}</span>,
                    })}
                </div>
                <div className="msg-line-desc">{t('SP_notice')}</div>
                {locale === 'cn' && <p className="hard-memo">{t('useTime_memo')}</p>}
                <div className="msg-line-link">
                    <span className="ef-blue-link">
                        <Link href="/400w-solar-panel">
                            {t('learn_more')}
                            <span className="ef-blue-link-more">
                                <EFArrowRightForAni />
                            </span>
                        </Link>
                    </span>
                </div>
            </div>
            <div className="a-img-box">
                <EFPic name={['img_4.webp', 'img_4.jpg']} className="fullImgs" />
            </div>
        </div>
    );
}
